import { ErrorToast, getConfig, SuccessToast, handleApiError } from "../Util";
import Axios from "../WebClient";

export const GetIncomingMonazamRequests = (
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  const params = {
    page,
    sortBy: 'date',
    sortOrder: 'DESC'
  };
  Axios.get("/request/monazam/incoming", { ...getConfig(), params })
    .then((res) => {
      const dataArray = res.data?.data?.data || res.data?.data || [];
      const pagination = res.data?.data?.pagination || res.data?.pagination;
      
      if (Array.isArray(dataArray)) {
        setRequests(dataArray);
        setTotalPages(pagination?.totalPages || 0);
      } else {
        setRequests([]);
        setTotalPages(0);
      }
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
    });
};

export const GetIncomingMonazamFilteredRequests = (
  values,
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  const params = {
    page,
    sortBy: 'date',
    sortOrder: 'DESC',
    ...(values?.currency && { currency: values.currency }),
    ...(values?.date && { date: values.date }),
    ...(values?.time && { time: values.time })
  };
  Axios.get("/request/monazam/incoming", { ...getConfig(), params })
    .then((res) => {
      const dataArray = res.data?.data?.data || res.data?.data || [];
      const pagination = res.data?.data?.pagination || res.data?.pagination;
      
      if (Array.isArray(dataArray)) {
        setRequests(dataArray);
        setTotalPages(pagination?.totalPages || 0);
      } else {
        setRequests([]);
        setTotalPages(0);
      }
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
    });
};

export const GetIncomingHGORequests = (
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  const params = {
    page,
    sortBy: 'date',
    sortOrder: 'DESC'
  };
  Axios.get("/request/hgo/incoming", { ...getConfig(), params })
    .then((res) => {
      const dataArray = res.data?.data?.data || res.data?.data;
      const pagination = res.data?.data?.pagination || res.data?.pagination;
      
      if (res.data && dataArray && Array.isArray(dataArray)) {
        setRequests(dataArray);
        setTotalPages(pagination?.totalPages || 0);
        setError("");
      } else {
        setRequests([]);
        setTotalPages(0);
        setError("");
      }
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
    });
};

export const GetIncomingHGOFilteredRequests = (
  values,
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  const params = {
    page,
    sortBy: 'date',
    sortOrder: 'DESC',
    ...(values?.currency && { currency: values.currency }),
    ...(values?.date && { date: values.date }),
    ...(values?.time && { time: values.time })
  };
  Axios.get("/request/hgo/incoming", { ...getConfig(), params })
    .then((res) => {
      const dataArray = res.data?.data?.data || res.data?.data;
      const pagination = res.data?.data?.pagination || res.data?.pagination;
      
      if (res.data && dataArray && Array.isArray(dataArray)) {
        setRequests(dataArray);
        setTotalPages(pagination?.totalPages || 0);
        setError("");
      } else {
        setRequests([]);
        setTotalPages(0);
        setError("");
      }
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
    });
};

export const GetMerchantMonazamRequests = (
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  Axios.get("/request/monazam/merchant?page=" + page, getConfig())
    .then((res) => {
      setRequests(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
    });
};

export const GetMerchantMonazamFilteredRequests = (
  values,
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  let params = "";
  {
    !!values?.currency
      ? (params += `currency=${values.currency}&`)
      : (params = params);
  }
  {
    !!values?.date ? (params += `date=${values.date}&`) : (params = params);
  }
  Axios.get(
    "/request/monazam/merchant?page=" +
      page +
      "&" +
      params.substring(0, params.length - 1),
    getConfig()
  )
    .then((res) => {
      setRequests(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
    });
};

export const GetMerchantHGORequests = (
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  Axios.get("/request/hgo/merchant?page=" + page, getConfig())
    .then((res) => {
      setRequests(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
    });
};

export const GetMerchantHGOFilteredRequests = (
  values,
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  let params = "";
  {
    !!values?.currency
      ? (params += `currency=${values.currency}&`)
      : (params = params);
  }
  {
    !!values?.date ? (params += `date=${values.date}&`) : (params = params);
  }
  Axios.get(
    "/request/hgo/merchant?page=" +
      page +
      "&" +
      params.substring(0, params.length - 1),
    getConfig()
  )
    .then((res) => {
      setRequests(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
    });
};

export const GetOutgoingMonazamRequests = (
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  Axios.get("/request/monazam/outgoing?page=" + page, getConfig())
    .then((res) => {
      setRequests(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
    });
};

export const GetOutgoingMonazamFilteredRequests = (
  values,
  setRequests,
  page,
  setLoading,
  setError,
  setTotalPages
) => {
  let params = "";
  {
    !!values?.status
      ? (params += `status=${values.status}&`)
      : (params = params);
  }
  {
    !!values?.categoryType
      ? (params += `categoryType=${values.categoryType}&`)
      : (params = params);
  }
  {
    !!values?.currency
      ? (params += `currency=${values.currency}&`)
      : (params = params);
  }
  {
    !!values?.date ? (params += `date=${values.date}&`) : (params = params);
  }
  Axios.get(
    "/request/monazam/outgoing?page=" +
      page +
      "&" +
      params.substring(0, params.length - 1),
    getConfig()
  )
    .then((res) => {
      setRequests(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
    });
};

export const GetOutgoingHGOFilteredRequests = (
  values,
  setRequests,
  page,
  setTotalPages,
  setLoading,
  setError
) => {
  let params = "";
  {
    !!values?.status
      ? (params += `status=${values.status}&`)
      : (params = params);
  }
  {
    !!values?.categoryType
      ? (params += `categoryType=${values.categoryType}&`)
      : (params = params);
  }
  {
    !!values?.currency
      ? (params += `currency=${values.currency}&`)
      : (params = params);
  }
  {
    !!values?.date ? (params += `date=${values.date}&`) : (params = params);
  }

  Axios.get(
    "/request/hgo/outgoing?page=" +
      page +
      "&" +
      params.substring(0, params.length - 1),
    getConfig()
  )
    .then((res) => {
      setRequests(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
    });
};

export const GetOutgoingHGORequests = (
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages
) => {
  Axios.get("/request/hgo/outgoing?page=" + page, getConfig())
    .then((res) => {
      setRequests(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
    });
};

export const CreateOutgoingRequests = (formData, setError, handleCreate) => {
  Axios.post("/request/outgoing", formData, {
    ...getConfig(),
    headers: {
      ...getConfig().headers,
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      handleCreate();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const CreateReversalIncomingRequest = (formData, setError, handleCreate) => {
  const currentDate = new Date().toISOString().split('T')[0];
  
  const requestData = {
    date: currentDate,
    type: "incoming",
    currency: formData.currency,
    transactionId: formData.transactionId,
    haji: formData.haji || formData.hajji,
    bankName: formData.bankName,
    amount: Number(formData.amount),
    narration: formData.narration,
    hgoId: formData.hgoId
  };
  
  if (formData.currency === "PKR" && formData.monazamBankAccountId) {
    requestData.monazamBankAccountId = formData.monazamBankAccountId;
  }
  
  Axios.post("/request/incoming/reverse", requestData, getConfig())
    .then((res) => {
      handleCreate();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const CreateIncomingRequests = (values, setError, handleCreate) => {
  Axios.post("/request/incoming", values, getConfig())
    .then((res) => {
      handleCreate();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const CreateMerchantRequests = (formData, setError, handleCreate) => {
  Axios.post("/request/merchant", formData, {
    ...getConfig(),
    headers: {
      ...getConfig().headers,
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      handleCreate();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const GetLoanRequests = (setData, setLoading, setError, page, setTotalPages, status = "pending") => {
  const params = {
    page,
    limit: 10,
    status
  };
  Axios.get("/loan-to-hgo", { ...getConfig(), params })
    .then((res) => {
      const dataArray = res.data?.data?.data?.loans || res.data?.data?.loans || [];
      const pagination = res.data?.data?.data || res.data?.data;
      
      if (Array.isArray(dataArray)) {
        setData(dataArray);
        setTotalPages(pagination?.totalPages || 0);
      } else {
        setData([]);
        setTotalPages(0);
      }
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching loan requests.");
    });
};

export const GetMonazamLoanRequests = (setData, setLoading, setError, page, setTotalPages, status = "pending") => {
  const params = {
    page,
    limit: 10,
    status
  };
  Axios.get("/loan-to-hgo/monazam", { ...getConfig(), params })
    .then((res) => {
      const dataArray = res.data?.data?.data?.loans || res.data?.data?.loans || [];
      const pagination = res.data?.data?.data || res.data?.data;
      
      if (Array.isArray(dataArray)) {
        setData(dataArray);
        setTotalPages(pagination?.totalPages || 0);
      } else {
        setData([]);
        setTotalPages(0);
      }
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching loan requests.");
    });
};

export const GetSameMonazamHGOs = (setHGOs, setLoading, setError) => {
  setLoading(true);
  Axios.get("/auth/same-monazam-hgos", getConfig())
    .then((res) => {
      if (res.data?.data && Array.isArray(res.data.data)) {
        setHGOs(res.data.data);
      } else {
        setHGOs([]);
      }
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching HGOs.");
    });
};

export const GetRegisteredHGOs = (setHGOs, setLoading, setError) => {
  setLoading(true);
  Axios.get("/auth/register-hgos", getConfig())
    .then((res) => {
      const dataArray = res.data?.data?.data || [];
      if (Array.isArray(dataArray) && dataArray.length > 0) {
        // Filter out "Unclaimed" from the HGO list
        const filteredHGOs = dataArray.filter(hgo => hgo.name !== "Unclaimed");
        setHGOs(filteredHGOs);
      } else {
        setHGOs([]);
      }
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching HGOs.");
    });
};

export const GetHGODetails = (setHGODetails, setLoading, setError) => {
  setLoading(true);
  Axios.get("/auth/hgo-details", getConfig())
    .then((res) => {
      if (res.data?.data) {
        setHGODetails(res.data.data);
      }
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching HGO details.");
    });
};

export const CreateLoanRequest = (formData, setError, handleCreate) => {
  Axios.post("/loan-to-hgo", formData, {
    ...getConfig(),
    headers: {
      ...getConfig().headers,
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      handleCreate();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const ApproveLoanRequestHGO = (id, formData, setError, handleApprove) => {
  Axios.patch(`/loan-to-hgo/${id}`, formData, {
    ...getConfig(),
    headers: {
      ...getConfig().headers,
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      if (handleApprove) {
        handleApprove();
      }
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const RejectLoanRequestHGO = (id, formData, setError, handleReject) => {
  Axios.patch(`/loan-to-hgo/${id}`, formData, {
    ...getConfig(),
    headers: {
      ...getConfig().headers,
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      if (handleReject) {
        handleReject();
      }
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const ApproveLoanRequestMonazam = (id, formData, setError, handleApprove) => {
  Axios.patch(`/loan-to-hgo/${id}`, formData, {
    ...getConfig(),
    headers: {
      ...getConfig().headers,
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      if (handleApprove) {
        handleApprove();
      }
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const RejectLoanRequestMonazam = (id, formData, setError, handleReject) => {
  Axios.patch(`/loan-to-hgo/${id}`, formData, {
    ...getConfig(),
    headers: {
      ...getConfig().headers,
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      if (handleReject) {
        handleReject();
      }
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const GetLoanRequestById = (id, setData, setLoading, setError) => {
  setLoading(true);
  Axios.get(`/loan-to-hgo/${id}`, getConfig())
    .then((res) => {
      if (res.data?.data) {
        setData(res.data.data);
      }
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching loan request details.");
    });
};

export const ApproveIncomingRequests = (id, setError, handleApprove) => {
  Axios.put("/request/incoming/approve/" + id, {}, getConfig())
    .then((res) => {
      handleApprove();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const RejectIncomingRequests = (id, setError, handleReject) => {
  Axios.put("/request/incoming/reject/" + id, {}, getConfig())
    .then((res) => {
      handleReject();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const ApproveMerchantRequests = (id, setError, handleApprove) => {
  Axios.put("/request/merchant/approve/" + id, {}, getConfig())
    .then((res) => {
      handleApprove();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const RejectMerchantRequests = (id, setError, handleReject) => {
  Axios.put("/request/merchant/reject/" + id, {}, getConfig())
    .then((res) => {
      handleReject();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const ApproveOutcomingRequests = (id, setError, handleApprove) => {
  Axios.put("/request/outgoing/approve/" + id, {}, getConfig())
    .then((res) => {
      handleApprove();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const RejectOutcomingRequests = (id, setError, handleReject) => {
  Axios.put("/request/outgoing/reject/" + id, {}, getConfig())
    .then((res) => {
      handleReject();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const GetConversionRates = (setPkrRate, setUsdRate) => {
  Axios.get("/conversion-rate", getConfig())
    .then((res) => {
      let pkrRate = res.data.data.ratePKRToSAR;
      let usdRate = res.data.data.rateUSDToSAR;
      if (pkrRate >= 1) {
        setPkrRate({
          pkr: 1,
          sar: pkrRate,
        });
      } else {
        setPkrRate({
          pkr: 1 / pkrRate,
          sar: 1,
        });
      }
      if (usdRate >= 1) {
        setUsdRate({
          usd: 1,
          sar: usdRate,
        });
      } else {
        setUsdRate({
          usd: 1 / usdRate,
          sar: 1,
        });
      }
    })
    .catch((err) => {
      ErrorToast(err?.response?.data?.message);
    });
};

export const SaveConversionRates = (pkrRateValues, usdRateValues, setError) => {
  Axios.post(
    "/conversion-rate",
    {
      ratePKRToSAR: pkrRateValues.sar / pkrRateValues.pkr,
      rateUSDToSAR: usdRateValues.sar / usdRateValues.usd,
    },
    getConfig()
  )
    .then((res) => {
      SuccessToast("Conversion rates updated successfully");
      if (setError) {
        setError(null);
      }
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const GetMonazamBankAccountsForHGO = (
  setBankAccounts,
  setLoading,
  setError
) => {
  setLoading(true);
  Axios.get("/request/hgo/monazam-bank-accounts", { ...getConfig() })
    .then((res) => {
      const pkrAccounts = res.data?.data?.data?.pkrAccounts || [];
      const fcyAccountData = res.data?.data?.data?.fcyAccount || null;
      
      const fcyAccount = fcyAccountData ? {
        id: "fcy-user-account",
        ...fcyAccountData
      } : null;
      
      setBankAccounts({
        bankAccounts: Array.isArray(pkrAccounts) ? pkrAccounts : [],
        fcyAccount
      });
      
      setError("");
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching bank accounts.");
    });
};

export const GetMonazamDetails = (
  setMonazamDetails,
  setLoading,
  setError
) => {
  if (setLoading) setLoading(true);
  Axios.get("/auth/monazam-details", { ...getConfig() })
    .then((res) => {
      if (res && res.data && res.data.data) {
        setMonazamDetails(res.data.data);
        if (setError) setError("");
      } else {
        if (setError) setError("No data received from server.");
      }
      if (setLoading) setLoading(false);
    })
    .catch((err) => {
      if (setLoading) setLoading(false);
      if (setError) setError("Error fetching Monazam details.");
      console.error("GetMonazamDetails error:", err);
    });
};

export const CreateUnclaimedRequest = (formData, setError, handleCreate) => {
  const currentDate = new Date().toISOString().split('T')[0];
  const currentTime = new Date().toTimeString().split(' ')[0];
  
  const requestData = {
    date: currentDate,
    time: currentTime,
    currency: formData.currency,
    narration: formData.narration,
    haji: formData.hajji,
    amount: Number(formData.amount.replace(/,/g, ''))
  };
  
  // Only include transactionId if it has a value (it's optional)
  if (formData.transactionId && formData.transactionId.trim()) {
    requestData.transactionId = formData.transactionId.trim();
  }
  
  if (formData.currency === "PKR" && formData.monazamBankAccountId) {
    requestData.monazamBankAccountId = formData.monazamBankAccountId;
  }
  
  Axios.post("/request/unclaimed-requests", requestData, getConfig())
    .then((res) => {
      handleCreate();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const CreateExpense = (formData, setLoading, setError, onSuccess) => {
  setLoading(true);
  setError("");
  
  const currentDate = new Date().toISOString().split('T')[0];
  const amountValue = parseFloat(formData.amount.replace(/,/g, ''));
  
  const requestData = {
    date: currentDate,
    currency: formData.currency,
    amount: amountValue,
    narration: formData.narration.trim()
  };
  
  // Only include monazamBankAccountId for PKR currency
  if (formData.currency === "PKR" && formData.monazamBankAccountId) {
    requestData.monazamBankAccountId = formData.monazamBankAccountId;
  }
  
  Axios.post("/ledger/expense", requestData, getConfig())
    .then((res) => {
      setLoading(false);
      // Handle response structure: { data: { message: "...", data: {...} } }
      if (res.data) {
        // res.data.data contains { message: "...", data: {...} }
        const responseData = res.data.data || res.data;
        if (onSuccess) {
          onSuccess(responseData);
        }
      }
    })
    .catch((err) => {
      setLoading(false);
      handleApiError(err, setError);
    });
};

export const ClaimUnclaimedRequest = (requestId, hgoId, setError, handleSuccess) => {
  Axios.post(`/request/unclaimed-requests/${requestId}/claim`, { hgoId }, getConfig())
    .then((res) => {
      SuccessToast(res.data?.message || "Unclaimed request has been claimed successfully!");
      if (handleSuccess) handleSuccess();
    })
    .catch((err) => {
      handleApiError(err, setError);
    });
};

export const GetUnclaimedRequests = (
  setRequests,
  setLoading,
  setError,
  page,
  setTotalPages,
  currency
) => {
  setLoading(true);
  const params = {
    page,
    limit: 10
  };
  
  Axios.get("/request/unclaimed-requests", { ...getConfig(), params })
    .then((res) => {
      const responseData = res.data?.data?.data || res.data?.data || {};
      const unclaimedRequests = responseData.unclaimedRequests || [];
      const pagination = {
        total: responseData.total || 0,
        page: responseData.page || 1,
        limit: responseData.limit || 10,
        totalPages: responseData.totalPages || 0
      };
      
      let filteredRequests = unclaimedRequests;
      if (currency) {
        filteredRequests = unclaimedRequests.filter(req => req.currency === currency);
      }
      
      setRequests(filteredRequests);
      setTotalPages(pagination.totalPages);
      setLoading(false);
      setError("");
    })
    .catch((err) => {
      setLoading(false);
      const errorMessage = err?.response?.data?.message || "Failed to fetch unclaimed requests";
      setError(errorMessage);
      ErrorToast(errorMessage);
    });
};
